import { render, staticRenderFns } from "./Version2Notice.vue?vue&type=template&id=043d4cc1&scoped=true"
import script from "./Version2Notice.vue?vue&type=script&lang=js"
export * from "./Version2Notice.vue?vue&type=script&lang=js"
import style0 from "./Version2Notice.vue?vue&type=style&index=0&id=043d4cc1&prod&lang=scss"
import style1 from "./Version2Notice.vue?vue&type=style&index=1&id=043d4cc1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "043d4cc1",
  null
  
)

export default component.exports